/**
 * Função utilitária para remover números de endereços
 * Remove números que aparecem no final do endereço ou após vírgula
 */

/**
 * Remove números do endereço, mantendo apenas o nome da rua/avenida
 * Exemplos:
 * - "Rua das Flores, 123" -> "Rua das Flores"
 * - "Av. Principal 456" -> "Av. Principal"
 * - "Rua ABC, 100, apto 101" -> "Rua ABC"
 */
export const removeAddressNumber = (address: string | null | undefined): string => {
  if (!address) return '';
  
  let cleaned = address.trim();
  
  // Remove números no final do endereço (após vírgula ou espaço)
  // Padrão: vírgula/espaço seguido de números opcionais com letras/aparatos
  cleaned = cleaned.replace(/,\s*\d+[\w\s]*$/i, '');
  
  // Remove números no final do endereço (sem vírgula antes)
  // Padrão: espaço seguido de números no final
  cleaned = cleaned.replace(/\s+\d+[\w\s]*$/i, '');
  
  // Remove padrões como "nº 123", "número 456", "num 789"
  cleaned = cleaned.replace(/\s*(nº|numero|num|number|#)\s*\d+[\w\s]*$/i, '');
  
  // Remove espaços extras e vírgulas no final
  cleaned = cleaned.replace(/[,\s]+$/, '').trim();
  
  return cleaned;
};
